import {roomGroup, sceneControls, views} from "../sceneManager";
import {ImageExport} from "./imageExport";
import {buildingGroup, measurementsGroup} from "../main";
import {Vector3, WebGLRenderer, WebGLRenderTarget} from "three";
import {exportHeight, exportWidth} from "../constants/outputConstants";
import {downloadFile} from "../utils/fileUtils";
import {showErrorMessage} from "../../ui/ui";
import {t} from "../../i18n";
import { enableAllLayers, enableLayerById } from "../utils/layerUtils";
import { toggleRoomLabeling } from "../models/rooms/roomGeneration";

export function exportImageCollection(zipDownload = false, callback = null, errorCallback = null) {
    //TODO: Vorlagenprojekte sind neu aber haben eine ID
    if (templateId === "new") {
        showErrorMessage(t("screenshot_save_first"));
        if (errorCallback !== null) {
            errorCallback();
        }
        return;
    }

    let objects = [buildingGroup];

    //Auflösung für den renderer. Ist erhöht für späteres Downsampling > Aliasing verhindern
    let renderWidth = exportWidth;
    let renderHeight = exportHeight;

    //Renderer und RenderTarget erzeugen. Zum Ressourcen sparen werden diese wiederverwendet
    let outputRenderTarget = new WebGLRenderTarget(renderWidth, renderHeight, {samples: 4});
    let outputRenderer = new WebGLRenderer();

    let imageExports = [];
    for (let i = 0; i < views.length; i++) {
        let view = views[i];
        console.log(view.name,view);
        let options = {
            uploadImage: false,
            width: exportWidth / 2,
            height: exportHeight / 2
        };
        if (view.name === "layout") {
            options.layers = [0,1,5,6,7,11,13,14,12, 20, 27];
            toggleRoomLabeling(true);
            let image = new ImageExport(view, [buildingGroup, measurementsGroup], templateId, options);
            imageExports.push({projectId:image.projectId, imageDataURL:image.imageDataURL, fileName: image.fileName});
            toggleRoomLabeling(false);
        } else {
            options.layers = [0,1,2,3,4,5,6,7,11,13];
            let image =new ImageExport(view, [buildingGroup], templateId, options);
            imageExports.push({projectId:image.projectId, imageDataURL:image.imageDataURL, fileName: image.fileName});
        }
    }

    saveImageCollectionToServer(imageExports, () => {
        //Dispose des Renderers, RenderTarget und Context
        outputRenderTarget.dispose();
        outputRenderTarget = null;
        outputRenderer.dispose();
        outputRenderer.forceContextLoss();
        outputRenderer = null;

        if (zipDownload) {
            getExportDownload(templateId);
            if (callback !== null) {
                callback();
            }
        } else {
            if (callback !== null) {
                callback();
            }
        }
    });
}

async function saveImageCollectionToServer(imageExports, callback) {
    if (imageExports.length <= 0) {
        return;
    }

    // Get the CSRF token value from the page (assuming it's stored in a <meta> tag)
    let csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const saveImageCollectionUrl = "/configurator/save-image-collection";

    let data = {
        projectId: imageExports[0].projectId,
        images: []
    };

    for (let i = 0; i < imageExports.length; i++) {
        if (imageExports[i].imageDataURL === null) {
            throw new Error("No image available to send.");
        }
        data.images.push({imageDataURL: imageExports[i].imageDataURL, name: imageExports[i].fileName});
    }

    let response = await fetch(saveImageCollectionUrl, {
        method: "POST",
        body: JSON.stringify(data), // Use the original data URL
        async: false,
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": csrfToken // Include the CSRF token in the header
        }
    });

    if (response.status === 200) {
        callback();
    } else {
        showErrorMessage(t("image_export_error"));
    }
}

export function exportSceneView(copyCameraMatrix = false) {
    //Auflösung für den renderer. Ist erhöht für späteres Downsampling > Aliasing verhindern
    //Auflösung ist quadratisch: Spätere Ansicht ist auch quadratisch

    //Renderer und RenderTarget erzeugen. Zum Ressourcen sparen werden diese wiederverwendet
   /*  let outputRenderTarget = new WebGLRenderTarget(renderWidth, renderHeight, {samples: 4});
    let outputRenderer = new WebGLRenderer(); */

    let cameraPosition = new Vector3(5, 2, 5);
    sceneControls.update();

    let options = {
        uploadImage: false,
        cameraPosition: cameraPosition,
        copyCameraMatrix: copyCameraMatrix,
        width: exportWidth / 2,
        height: exportHeight / 2,
        layers: [0,1,2,3,4, 5, 6, 7, 11, 13, 30]
    };
    let view = views[1];
    let objects = [buildingGroup];
    let imageExport = new ImageExport(/* outputRenderer, outputRenderTarget, */ view, objects, templateId, options);

    //Dispose des Renderers, RenderTarget und Context
    /* outputRenderTarget.dispose();
    outputRenderTarget = null;
    outputRenderer.dispose();
    outputRenderer.forceContextLoss();
    outputRenderer = null; */
    

    return imageExport.imageDataURL;
}

export function exportLayoutView() {
    
    toggleRoomLabeling(true);


    let renderWidth = exportWidth;
    let renderHeight = exportHeight;

    let options = {
        uploadImage: false,
        width: renderWidth / 2,
        height: renderHeight / 2,
        layers: [0, 1, 5, 6, 7, 11,13,14,12, 20, 27]
    };

    let view = views[0];
    let objects = [buildingGroup, measurementsGroup];
    let imageExport = new ImageExport(view, objects, templateId, options);

        
    toggleRoomLabeling(false);
    
    return imageExport.imageDataURL; 
}

function getExportDownload() {
    downloadFile("configurator/download-image/" + templateId, "Export.zip", "Beim Download des Bildexports ist ein Fehler aufgetreten.", "Bildexport erfolgreich erzeugt und heruntergeladen.");
}
